import api from './api';

export interface FinanceOverviewData {
  range: { from: string; to: string };
  metrics: {
    gmv: number;
    netRevenue: number;
    tax: number;
    totalDiscount: number;
    refunds: number;
    commission: { realized: number | null; estimated: number | null };
    profit: {
      realized: number | null;
      expected: number | null;
      gatewayFees: number;
      referralCost?: number;
      /** کارمزد اقساطی دریافتی از خریداران (دیجی‌پی) — پس از کسر تعدیل‌های برگشتی */
      surchargeCollected?: number;
      surchargeCount?: number;
    };
    escrowPending: number;
    availableBalance: number;
    blockedFunds: number;
    liabilities: { wallet: number; points: number };
    banner?: {
      revenue: number;      // کل تاکنون (snapshot)
      netRevenue: number;   // خالص تاکنون
      tax: number;
      refunded: number;
      count: number;
      rangeRevenue: number; // در بازه انتخابی
      rangeCount: number;
    };
    inspection?: {
      feesTotal: number;
      feesCount: number;
      // ✅ NEW (2026-05-04): platform share + blocked metrics
      platformShare?: number;
      completedCount?: number;
      blockedAmount?: number;
      blockedCount?: number;
      penalties: {
        pending: number;
        approved: number;
        waived: number;
      };
    };
  };
}

const financeService = {
  // `opts.silentForbidden` lets a caller (e.g. the overview Dashboard widget) suppress the
  // global 403 → /403 redirect so a missing finance permission only hides that widget.
  getOverview: async (
    params?: { from?: string; to?: string; unit?: 'IRR' | 'IRT'; scale?: 'raw' | 'thousand' | 'million' },
    opts?: { silentForbidden?: boolean },
  ) => {
    const query: string[] = [];
    if (params?.from) query.push(`from=${encodeURIComponent(params.from)}`);
    if (params?.to) query.push(`to=${encodeURIComponent(params.to)}`);
    if (params?.unit) query.push(`unit=${params.unit}`);
    if (params?.scale) query.push(`scale=${params.scale}`);
    const qs = query.length ? `?${query.join('&')}` : '';
    // api.get استخراج data داخلی را انجام می‌دهد، پس مستقیم FinanceOverviewData برمی‌گرداند
    return api.get<FinanceOverviewData>(
      `/admin/finance/overview${qs}`,
      opts?.silentForbidden ? ({ silentForbidden: true } as any) : undefined,
    );
  },

  getReleaseCalendar: async (daysAhead = 30) => {
    return api.get<Array<{ date: string; amount: number; count: number }>>(
      `/admin/finance/release-calendar?daysAhead=${daysAhead}`
    );
  },

  getLiabilities: async () => {
    return api.get<{ wallet: number; points: number; pointsRate: number }>(
      '/admin/finance/liabilities'
    );
  }
};

export default financeService;


